<section style="z-index: 55;" class="col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2 fadeInUp" *ngIf="!upsellbookingStatus.showUpsellScreen">
  <h1 class="margin-bottom-16 text-dark-blue h1">{{appCopy.panelHeader['timeslotTitle'+selectedLanguage]}}</h1>

  <div class="loader-container" *ngIf="!dataLoaded">
    <div class="flex-always flex-wrap timeslot-dates">
      <div class="flightDateSelection"></div>
      <div class="flightDateSelection"></div>
    </div>
    <div class="buttonContinueload"></div>
  </div>

  <form #formBagPickupTimeDate="ngForm" id="pickUpTime" name="formBagPickupTimeDate" *ngIf="dataLoaded" novalidate>
    <!-- SBB Confirmation Success-->
    <div class="alert alert-success flex-always" *ngIf="isSbbSubsidyApplied">
      <i class="icon">tick</i>
      <div>
        <h4>{{ appCopy.panelHeader['discountAddedTitle'+selectedLanguage] }}</h4>
        <div>{{ appCopy.panelHeader['sbbDiscountConfirmation'+selectedLanguage] }}</div>
      </div>
    </div>

    <!-- Cat Discount Confirmation Success-->
    <div class="alert alert-success flex-always" *ngIf="isCatDiscountApplied">
      <i class="icon">tick</i>
      <div>
        <h4>{{ appCopy.panelHeader['discountAddedTitle'+selectedLanguage] }}</h4>
        <div>{{ appCopy.panelHeader['catDiscountConfirmation'+selectedLanguage] }}</div>
      </div>
    </div>

    <!-- promo - valid -->
    <div *ngIf="timeslotMessageDetails.showMessage && timeslotMessageDetails.isValid && timeslotMessageDetails?.translationMessage.length > 0"
      class="alert alert-success flex-always">
      <i class="icon">tick</i>
      <div>
        <h4>{{appCopy.panelHeader[timeslotMessageDetails.title+selectedLanguage]
          ? appCopy.panelHeader[timeslotMessageDetails.title+selectedLanguage]
          : timeslotMessageDetails.title}}</h4>
        <!-- <div [innerHtml]="timeslotMessageDetails.message"></div> -->
        <div>
          <p *ngFor="let item of  timeslotMessageDetails.translationMessage">{{
            appCopy.panelHeader[item+selectedLanguage]
            ? appCopy.panelHeader[item+selectedLanguage]
            .replace('{rewardAmount}',
            timeslots.timeSlotPromotion.translationValidationErrors.parameters['rewardAmount'])
            .replace('{rewardTypeDesignator}',
            timeslots.timeSlotPromotion.translationValidationErrors.parameters['rewardTypeDesignator'])
            : appCopy.panelHeader[item+selectedLanguage]
            }}</p>
        </div>
      </div>
    </div>
    <!-- promo - invalid -->
    <div *ngIf="timeslotMessageDetails.showMessage && !timeslotMessageDetails.isValid && timeslotMessageDetails?.translationMessage.length > 0"
      class="alert alert-danger flex-always">
      <i class="icon">alert</i>
      <div>
        <h4>{{appCopy.panelHeader[timeslotMessageDetails.title+selectedLanguage] ?
          appCopy.panelHeader[timeslotMessageDetails.title+selectedLanguage] : timeslotMessageDetails.title}}</h4>
        <!-- <div [innerHtml]="timeslotMessageDetails.message"></div> -->
        <div>
          <p *ngFor="let item of  timeslotMessageDetails.translationMessage">
            {{appCopy.panelHeader[item+selectedLanguage]
            ? appCopy.panelHeader[item+selectedLanguage]
            : item }}</p>
        </div>
      </div>
    </div>

    <!-- product tier - valid -->
    <div *ngIf="timeslotMessageProductTierDetails.showMessage && timeslotMessageProductTierDetails.isValid"
      class="alert alert-success flex-always">
      <i class="icon">tick</i>
      <div>
        <h4>{{timeslotMessageProductTierDetails.title}}</h4>
        <div [innerHtml]="timeslotMessageProductTierDetails.message"></div>
      </div>
    </div>
    <!-- product tier - invalid -->
    <div *ngIf="timeslotMessageProductTierDetails.showMessage && !timeslotMessageProductTierDetails.isValid"
      class="alert alert-danger flex-always">
      <i class="icon">alert</i>
      <div>
        <h4 class="hidden-sm hiddne-xs">{{timeslotMessageProductTierDetails.title}}</h4>
        <h5 class="hidden-lg hidden-md">{{timeslotMessageProductTierDetails.title}}</h5>
        <div [innerHtml]="timeslotMessageProductTierDetails.message"></div>
      </div>
    </div>

    <!-- show warning if amend that price may have increased -->
    <div *ngIf="bookingType === 'amend'" class="alert alert-danger">
      <p>{{ appCopy.panelHeader['amendWarning'+selectedLanguage] }}</p>
    </div>

    <div class="radio-pills hubdrop-timeslot margin-bottom-16">
      <div *ngIf="showCalendar" class="radio radio--pill radio--calendar"
        [class.flex__item--order-last]="flightDirection === 2">
        <app-datepicker [selectedDate]="!isRadioDate && currentDate" [minDate]="calendarMinDate"
          [maxDate]="calendarMaxDate" [disableDates]="disableDates" [forTimeslot]="true" [labelText]="calendarLabelText"
          (dateChange)="setSelectedDate($event)">
        </app-datepicker>
      </div>

      <div *ngFor="let date of radioDates; let i = index" class="radio radio--pill">
        <input type="radio" name="date" [id]="'date' + i" [value]="date.dateTime" [ngModel]="isRadioDate && currentDate && date.isAvailable"
          (change)="setSelectedDate(date.dateTime, date)" required>
        <label [for]="'date' + i" [ngClass]="date.isAvailable ? 'enable' : 'disable'">
          <p class="label__display">
            <span class="label__checkbox"></span>
              {{ date.dateTime | date:'E d MMM yyyy' : '' : languageCode }}
            <span *ngIf="showPlaneIconAtIndex === i" class="icon icon--small">plane_solid</span>
          </p>
          <p class="label__date text-caption">{{ date.timeslotGroups[0].timeslots[0].startTime + '-' + date.timeslotGroups[0].timeslots[0].endTime }}
          </p>
          <p class="label__date text-caption">{{ (date.timeslotGroups[0].currencySymbol === 'CHF' ? date.timeslotGroups[0].currencySymbol + ' ' : date.timeslotGroups[0].currencySymbol) +  date.timeslotGroups[0].timeslots[0].totalPriceMajor }}
          </p>
        </label>
      </div>
    </div>

    <div class='booking-summary__bagsDropdown' *ngIf="bookingType === 'amend'">
      <div *ngIf="toggleDropdown" [@Dropdown] class="dropdownBody">
        <!-- Bags -->
        <div class="dropdown-item">
          <div class='flex-always g-23'>
            <div class="bagtooltip margin-right-8">
              <span class="icon-span icon-span-small tooltip-trigger-text">
                <span class="icon-information icon-black icon_12">
                </span>
              </span>
              <span
                class="tooltiptext tooltip-right-bottom">{{appCopy.panelHeader['bagInfoText'+selectedLanguage]}}</span>
            </div>
            <span class="text-extra-bold">{{ appCopy.panelHeader[bagItems.bags > 1 ? 'bagsSelectText' +
              selectedLanguage :
              'bagSelectText' + selectedLanguage] }}</span>
          </div>
          <div class='bag--buttons flex-always'>
            <button (click)="updateBagItems(bagItems.bags-1, 'bags')"
              class='iconBtn icon-span icon-span-small margin-right-8'
              [disabled]="bagItems.bags === 0 || showLoader || isPriceLoading || isTimeslotLoading">
              <span class="icon-minus icon-black icon_16">
              </span>
            </button>
            <strong class="dropdown-item--value">{{bagItems.bags}}</strong>
            <button (click)="updateBagItems(bagItems.bags+1, 'bags')"
              class='iconBtn icon-span icon-span-small margin-left-8'
              [disabled]="virtualBags > 25 || showLoader || isPriceLoading || isTimeslotLoading">
              <span class="icon-plus-outline icon-black icon_16">
                <span class='path1'></span>
                <span class='path2'></span>
              </span>
            </button>
          </div>
        </div>
        <!-- child Equipment -->
        <div class="dropdown-item">
          <div class='flex-always g-23'>
            <div class="bagtooltip margin-right-8">
              <span class="icon-span icon-span-small tooltip-trigger-text">
                <span class="icon-information icon-black icon_12">
                </span>
              </span>
              <span
                class="tooltiptext tooltip-right-bottom">{{appCopy.panelHeader['childItemInfoText'+selectedLanguage]}}</span>
            </div>
            <span class="text-extra-bold">{{ appCopy.panelHeader['childItemLable' + selectedLanguage] }}</span>
          </div>
          <div class='bag--buttons flex-always'>
            <button (click)="updateBagItems(bagItems.childEquipment-1, 'childEquipment')"
              class='iconBtn icon-span icon-span-small margin-right-8'
              [disabled]="bagItems.childEquipment === 0 || showLoader || isPriceLoading || isTimeslotLoading">
              <span class="icon-minus icon-black icon_16">
              </span>
            </button>
            <strong class="dropdown-item--value">{{bagItems.childEquipment}}</strong>
            <button (click)="updateBagItems(bagItems.childEquipment+1, 'childEquipment')"
              class='iconBtn icon-span icon-span-small margin-left-8'
              [disabled]="virtualBags > 25 || showLoader || isPriceLoading || isTimeslotLoading">
              <span class="icon-plus-outline icon-black icon_16">
                <span class='path1'></span>
                <span class='path2'></span>
              </span>
            </button>
          </div>
        </div>
        <!-- Oversize item -->
        <div class="dropdown-item">
          <div class='flex-always g-23'>
            <div class="bagtooltip margin-right-8">
              <span class="icon-span icon-span-small tooltip-trigger-text">
                <span class="icon-information icon-black icon_12">
                </span>
              </span>
              <span
                class="tooltiptext tooltip-right-bottom">{{appCopy.panelHeader['supportItemInfoText'+selectedLanguage]}}</span>
            </div>
            <span class="text-extra-bold">{{ appCopy.panelHeader['supportItemLable' + selectedLanguage] }}</span>
          </div>
          <div class='bag--buttons flex-always'>
            <button (click)="updateBagItems(bagItems.oversizeItem-1, 'oversizeItem')"
              class='iconBtn icon-span icon-span-small margin-right-8'
              [disabled]="bagItems.oversizeItem === 0 || showLoader || isPriceLoading || isTimeslotLoading">
              <span class="icon-minus icon-black icon_16">
              </span>
            </button>
            <strong class="dropdown-item--value">{{bagItems.oversizeItem}}</strong>
            <button (click)="updateBagItems(bagItems.oversizeItem+1, 'oversizeItem')"
              class='iconBtn icon-span icon-span-small margin-left-8'
              [disabled]="virtualBags > 25 || showLoader || isPriceLoading || isTimeslotLoading">
              <span class="icon-plus-outline icon-black icon_16">
                <span class='path1'></span>
                <span class='path2'></span>
              </span>
            </button>
          </div>
        </div>
        <div class='bag-error'>
          <p *ngIf="virtualBags === 0" class='has-error'>{{appCopy.panelHeader['zeroBagItemError'+selectedLanguage]}}
          <p *ngIf="virtualBags > 25" class='has-error'>{{appCopy.panelHeader['maxBagItemError'+selectedLanguage]}}
          </p>
        </div>
      </div>
    </div>

    <button id="formBagPickupTimeDate-submit" type="button" style="margin-top: 200px;"
      [ngClass]="{'Buttonloading' : isTimeslotLoading || isPriceLoading || showLoader}" class="btn btn-block btn-purple margin-bottom-24" (click)="handleSubmit($event)"
        [disabled]="
        setSelectedDateVal ||
        showLoader
        || virtualBags > 25
        || virtualBags === 0
        ||isTimeslotLoading
        || isPriceLoading
        || (bookingType !== 'amend' && timeslotsData.selectedTimeslotId === null)
        || (bookingType === 'amend' && !bookingData.booking.changedLocationFlag && !bookingData.booking.changedBagsFlag && !bookingData.booking.changedTimeslotFlag && price.priceHistory.majorPriceDifference === 0)
        || (bookingType === 'amend' && bookingData.booking.changedLocationFlag && !bookingData.booking.changedTimeslotFlag)">
        <!-- <div class="loader-container-btn" *ngIf="isTimeslotLoading || isPriceLoading || showLoader">
          <div class="loader loader--white">
            <svg class="circular" viewBox="25 25 50 50">
              <circle class="path" cx="50" cy="50" r="20" />
            </svg>
          </div>
        </div> -->
        <span *ngIf="!isTimeslotLoading && !isPriceLoading && !showLoader">
          {{appCopy.panelHeader['buttonContinue'+selectedLanguage]}}
        </span>
      </button>
  </form>
</section>
